import {useState, useContext} from 'react';
import {UserContext, UpdateUserContext} from "../../App"
import './Devoirs.css'
import {color_note} from "../Fonctions"
import {tab_color_bg} from "../config/Config"



export function Devoirs ({auth, updateUser}) {
  const {currentUser} = useContext(UserContext)
  const user = currentUser
  const updateUsercontext = useContext(UpdateUserContext)
  
  // Dates
  const dat = new Date()
  const dat_month = dat.getMonth()+1 < 10 ? '0'+ (dat.getMonth()+1) : dat.getMonth()+1
  const dat_day = dat.getDate() < 10 ? '0'+ (dat.getDate()) : dat.getDate()
  const today = dat.getFullYear() + '-' + dat_month + '-' + dat_day
  const cleanDate = (date) => date.slice(-2)+'/'+date.slice(-5,-3)

  let current_classe = ''
  const add_br = (classe) => {
    if(current_classe !== classe) {
      current_classe = classe
      return <br/>
    }
  }
  const [devoir_cree, setDevoir_cree] = useState({
    classe:user.liste_classes[0],
    nb_question:'3',
    etoile:'',
    niveau:'',
    titre:'',
    titre_active:false,
    comm_active:'',
    champ_valid:true,
    optionnel:'Non',
    date_limit:'Non',
    date_limit_value:today,
    selection:{},
    search:'',
    config_supp:'',
    config_supp_active:false,
  })
  const cleanDevoir_cree = (param) => {
    setDevoir_cree({...devoir_cree, classe:user.liste_classes[0], titre:'', titre_active:false, comm_active:'', niveau:'', nb_question:'3', etoile:'', selection:{}, config_supp_active:param === 'supprMesquestions'})
  }
  
  const [msg, setMsg] = useState({
    diff_maj:'',
    suppr_devoir:'',
  })

  const cleanMsg = (name) => {
    setTimeout(e => {
          setMsg({...msg, [name]:''})
        }, 3000)
  }

  const sendData = (auth, name) => {
    fetch("https://maths-au-quotidien.fr/react-automaths/api-database.php", {
      method: 'POST',
      body: JSON.stringify(auth)
    })
    .then(response => response.json())
    .then(data => {
      setMsg({...msg, [name]:data})
      cleanMsg(name)
      updateUsercontext()
      cleanDevoir_cree()
    })
    .catch(err => console.log(err))
  }

  const handleSubmit = (e) => {
    const name = e.target.attributes.name.nodeValue
    let confirm = window.confirm("Voulez-vous vraiment supprimer la demande de faire ce devoir ?");
    if (!confirm) {return}
    auth = {...auth, action:name, field:e.target.id}
    sendData(auth, name)
  }
  const moyenne = (eleves) => {
    let moy = 0
    let nb_question = 0
    eleves?.forEach(e => {
      moy = moy + e.note*e.nb_question
      nb_question = nb_question + e.nb_question*1
    })
    return Math.round(moy*10/nb_question)/10
  }

  let color_devoir = {}
  
  let k = 0
  user.liste_classes?.forEach(c => {
    color_devoir = {...color_devoir, [c]:tab_color_bg[k]}
    k++
  })
  
  //console.log(user)
  return (
    <div>
      {user.mes_devoirs.length ? 
      <div id="liste_devoirs" className="content max" style={{textAlign:"left"}} >
        <h1>Mes {user.mes_devoirs.length} devoirs en cours</h1>
        {
          user.mes_devoirs.length > 9 && <span style={{color:'steelblue'}}>ℹ️ La suppression de la demande de faire un devoir ne supprime pas les résultats de ce devoir.</span>
        }
        {msg.suppr_devoir ? <span dangerouslySetInnerHTML={{ __html:msg.suppr_devoir}}></span> : ''}
        <div >
         {user.mes_devoirs.map((devoir, k) => 
          <span key ={k}>
            {add_br(devoir.classe)}
            <div className="message resultat" title={devoir.activite.replaceAll('__', '\u000d')} style={{backgroundColor:color_devoir[devoir.classe]}} >
              <div className="info_mess">{devoir.donne_le}<br/>{!devoir.date_limit.includes('0000') ? <span className="date_limit_arrow">{cleanDate(devoir.date_limit)}</span>:''}</div>
              {devoir.facultatif === '1' ? <div className="facultatif_mark" title="Devoir optionnel"></div> : ''}
              {devoir.listeChoix ? <div className="choisi_mark" title="Devoir dont les questions sont choisies"></div> : ''}
              <div name="suppr_devoir" id={devoir.id} className="suppr_serie" onClick={handleSubmit} title="La suppression de la demande de faire ce devoir ne supprimera pas les résultats de ce devoir." ></div>
              <div className="note_serie">{devoir.classe}</div> <div className="nb_question">{devoir.listeChoix ? devoir.listeChoix.split('_').length : devoir.nb_question}Q</div> {devoir.etoile === '4' ? <span style={{color:"steelblue", fontWeight:"bold"}} >🅳</span> : '⭐'.repeat(devoir.etoile)}
              <div>{devoir.title || devoir.activite.split('__')[0] + (devoir.activite.split('__')[1] ? '...' : '')}</div>
              {devoir.consigne && <div className="consigne">{devoir.consigne}</div>}
              {user.activite_faites[devoir.classe][devoir.activite] ? 
                <span>
                  <span className="green">{user.activite_faites[devoir.classe][devoir.activite]?.length}/{user.mes_classes[devoir.classe]?.length}</span> - <span className={color_note(moyenne(user.activite_faites[devoir.classe][devoir.activite]))}>{moyenne(user.activite_faites[devoir.classe][devoir.activite])}%</span>
                </span>:''
              }
            </div>
          </span>
          )}
        </div>
      </div>
      : <>
          <br/><br/><br/><br/><br/>
          <div className="info"><br/>Vous n'avez pas de demande de faire un devoir.<br/><br/></div>
        </>
      }

    </div>
  );
}